<template>
  <div id="app" class="bg-home relative w-full font-sans antialiased lg:flex lg:flex-wrap lg:content-between">
    <nav
      :class="open ? 'pt-0' : 'pt-6'"
      class="fixed z-10 mx-auto flex w-full flex-wrap items-center justify-end lg:relative lg:pt-0">
      <div class="block lg:hidden">
        <button
          class="absolute right-6 top-6 flex items-center rounded border-2 border-black px-3 py-2 text-black hover:border-black hover:text-black"
          @click="toggle">
          <svg class="h-4 w-4 fill-current text-black" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div
        :class="open ? 'block' : 'hidden'"
        class="w-full flex-grow bg-white p-6 pt-10 shadow-lg transition delay-75 duration-300 lg:flex lg:w-auto lg:items-center lg:bg-opacity-20 lg:bg-opacity-40 lg:pt-6 lg:text-center lg:shadow-none 2xl:bg-opacity-10">
        <div class="flex flex-col gap-x-2 gap-y-4 text-sm lg:flex-grow lg:flex-row lg:items-center lg:justify-center">
          <a href="https://www.amazonas.am.gov.br" target="_blank">
            <img
              src="https://apstatic.prodam.am.gov.br/images/logo_governo/logo-gov-horizontal.png"
              alt="Governo de Estado do Amazonas"
              class="h-8 md:inline md:h-10" />
          </a>
          <a class="menu-item" href="https://www.detran.am.gov.br" target="_blank"> Detran Amazonas </a>
          <a class="menu-item" href="#cnh-social">CNH Social</a>
          <a class="menu-item" href="#motociclista-legal">Motociclista Legal</a>
          <a class="menu-item" href="#cnh-na-escola">CNH na Escola</a>
          <router-link class="menu-item" to="/videos">Vídeos</router-link>
          <LoginLogoutButton />
          <div class="flex items-center gap-2">
            <a
              class="inline-block align-bottom"
              href="https://www.facebook.com/DetranAmazonasOficial"
              rel="noopener noreferrer"
              target="_blank">
              <svg id="Ebene_1" class="w-8" data-name="Ebene 1" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M30,15A15,15,0,1,0,12.66,29.82V19.34H8.85V15h3.81V11.7c0-3.76,2.24-5.84,5.67-5.84a23.07,23.07,0,0,1,3.36.29V9.84H19.79a2.17,2.17,0,0,0-2.44,2.34V15H21.5l-.67,4.34h-3.5V29.82A15,15,0,0,0,30,15Z" />
                <path
                  d="M20.84,19.34,21.5,15H17.34V12.19a2.17,2.17,0,0,1,2.44-2.34h1.89V6.15a23.07,23.07,0,0,0-3.36-.29c-3.43,0-5.67,2.08-5.67,5.84V15H8.85v4.34h3.81V29.82a15.16,15.16,0,0,0,4.69,0V19.34Z"
                  fill="#fff" />
              </svg>
            </a>
            <a
              class="inline-block align-bottom"
              href="https://www.instagram.com/detranamazonas/"
              rel="noopener noreferrer"
              target="_blank">
              <svg id="Logo" class="w-8" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="15" />
                <path
                  d="M15,6c2.94,0,3.29,0,4.45.06a6.09,6.09,0,0,1,2,.38,3.64,3.64,0,0,1,2.09,2.09,6.09,6.09,0,0,1,.38,2C24,11.71,24,12.06,24,15s0,3.29-.06,4.45a6.09,6.09,0,0,1-.38,2,3.64,3.64,0,0,1-2.09,2.09,6.09,6.09,0,0,1-2,.38C18.29,24,17.94,24,15,24s-3.29,0-4.45-.06a6.09,6.09,0,0,1-2-.38,3.64,3.64,0,0,1-2.09-2.09,6.09,6.09,0,0,1-.38-2C6,18.29,6,17.94,6,15s0-3.29.06-4.45a6.09,6.09,0,0,1,.38-2A3.64,3.64,0,0,1,8.51,6.42a6.09,6.09,0,0,1,2-.38C11.71,6,12.06,6,15,6m0-2c-3,0-3.36,0-4.54.07a8.08,8.08,0,0,0-2.67.51A5.63,5.63,0,0,0,4.57,7.79a8.08,8.08,0,0,0-.51,2.67C4,11.64,4,12,4,15s0,3.36.07,4.54a8.08,8.08,0,0,0,.51,2.67,5.63,5.63,0,0,0,3.22,3.22,8.08,8.08,0,0,0,2.67.51C11.64,26,12,26,15,26s3.36,0,4.54-.07a8.08,8.08,0,0,0,2.67-.51,5.63,5.63,0,0,0,3.22-3.22,8.08,8.08,0,0,0,.51-2.67C26,18.36,26,18,26,15s0-3.36-.07-4.54a8.08,8.08,0,0,0-.51-2.67,5.63,5.63,0,0,0-3.22-3.22,8.08,8.08,0,0,0-2.67-.51C18.36,4,18,4,15,4Z"
                  fill="#fff" />
                <path
                  d="M15,9.35A5.65,5.65,0,1,0,20.65,15,5.65,5.65,0,0,0,15,9.35Zm0,9.32A3.67,3.67,0,1,1,18.67,15,3.67,3.67,0,0,1,15,18.67Z"
                  fill="#fff" />
                <circle cx="20.87" cy="9.13" fill="#fff" r="1.32" />
              </svg>
            </a>
            <a
              class="inline-block align-bottom"
              href="https://twitter.com/detranamazonas"
              rel="noopener noreferrer"
              target="_blank">
              <svg id="Logo" class="w-8" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15" cy="15" r="15" />
                <g id="Logo-2" data-name="Logo">
                  <path
                    id="white_background"
                    d="M23.75,10.51c0,.19,0,.39,0,.58A12.76,12.76,0,0,1,10.92,23.94h0a12.78,12.78,0,0,1-6.92-2A9.18,9.18,0,0,0,5.07,22,9.06,9.06,0,0,0,10.68,20a4.52,4.52,0,0,1-4.22-3.13,4.5,4.5,0,0,0,2-.08A4.51,4.51,0,0,1,4.88,12.4v-.06a4.48,4.48,0,0,0,2,.56,4.52,4.52,0,0,1-1.4-6,12.81,12.81,0,0,0,9.3,4.72,4.52,4.52,0,0,1,7.69-4.12,9.06,9.06,0,0,0,2.87-1.1,4.53,4.53,0,0,1-2,2.5A9,9,0,0,0,26,8.17,9.17,9.17,0,0,1,23.75,10.51Z"
                    data-name="white background"
                    fill="#fff" />
                </g>
              </svg>
            </a>
            <a
              class="inline-block align-bottom"
              href="https://www.youtube.com/c/DetranAMOficial"
              rel="noopener noreferrer"
              target="_blank">
              <svg id="Layer_1" class="w-8" data-name="Layer 1" viewBox="0 0 31 31" xmlns="http://www.w3.org/2000/svg">
                <circle cx="15.5" cy="15.5" fill="#212121" r="15" stroke="#000" stroke-miterlimit="10" />
                <path
                  d="M25.78,9.55a2.83,2.83,0,0,0-2-2C22,7.07,15,7.07,15,7.07s-7,0-8.79.47a2.83,2.83,0,0,0-2,2A29.66,29.66,0,0,0,3.75,15a29.66,29.66,0,0,0,.47,5.45,2.83,2.83,0,0,0,2,2c1.75.47,8.79.47,8.79.47s7,0,8.79-.47a2.83,2.83,0,0,0,2-2A29.66,29.66,0,0,0,26.25,15,29.66,29.66,0,0,0,25.78,9.55ZM12.7,18.35V11.65L18.58,15Z"
                  fill="#fff"
                  transform="translate(0.5 0.5)" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </nav>

    <!-- <div class="logo-detran-cidadao h-screen-40"></div> -->

    <div class="lg: w-full lg:-mt-28">
      <vue-carousel :data="sliders"></vue-carousel>
    </div>

    <Menu page="/">
      <div class="flex w-full justify-center bg-yellow-400 py-3">
        <div class="w-4/5 text-center">
          <span class="font-bold uppercase text-gray-900"> Confira a lista dos selecionados de acordo com a fase</span>
        </div>
      </div>
    </Menu>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import VueCarousel from '@chenfengyuan/vue-carousel';
import Menu from '../components/Menu.vue';
import LoginLogoutButton from '../components/LoginLogoutButton.vue';

export default defineComponent({
  name: 'Cabecalho',
  components: {
    Menu,
    VueCarousel,
    LoginLogoutButton,
  },
  setup() {
    const sliders = [
      {
        small: 'img/sliders/inscricoes-2026/inscricoes-2026-small.jpg',
        medium: 'img/sliders/inscricoes-2026/inscricoes-2026-medium.jpg',
        large: 'img/sliders/inscricoes-2026/inscricoes-2026-large.jpg',
      },
      {
        small: 'img/sliders/banner-capital-small.png',
        medium: 'img/sliders/banner-capital-medium.png',
        large: 'img/sliders/banner-capital-large.png',
        link: 'https://www.detran.am.gov.br/',
      },
      {
        small: 'img/sliders/banner-interior-small.png',
        medium: 'img/sliders/banner-interior-medium.png',
        large: 'img/sliders/banner-interior-large.png',
      },
    ].map((slide_item) => {
      const pre = slide_item.link ? `<a href="${slide_item.link}">` : ``;
      const end = slide_item.link ? `</a>` : ``;

      return (
        pre +
        `<picture>
            <source media="(max-width:639px)" srcset="${slide_item.small}" />
            <source media="(max-width:1023px)" srcset="${slide_item.medium}" />
            <source media="(max-width:1535px)" srcset="${slide_item.large}" />
            <img src="${slide_item.large}" alt="Comunicado de Atenção" class="w-full" />
          </picture>` +
        end
      );
    });

    const open = ref(false);
    const toggle = () => {
      open.value = !open.value;
    };

    return { open, toggle, sliders };
  },
});
</script>
